export function cdnUrl(bucket: string, path: string): string {
  const base = import.meta.env.VITE_CDN_URL
  if (!base || !path) return ''
  return `${base}/${bucket}/${path}`
}
